import {Media, SharingObject} from '../media/media';

export interface Remote extends SharingObject {
    action?: Action;
    cpoRef?: string;
    emoRef?: string;
    externalId?: string;
    media?: Media;
    request?: RemoteRequest;
    response?: Response;
}

export interface RemoteRequest {
    chargePointRef?: string;
    chargeRef?: string;
    holdingPeriod?: number;
    plugRef?: string;
    powerAsked?: number;
    requestDate?: number;
    startingMediumCode?: string;
    stationRef?: string;
    stoppingMediumCode?: string;
}

export interface RemoteResponse extends SharingObject {
    authorizeRef?: string;
    authorizedMaxPower?: number;
    chargePointName?: string;
    chargePointRef?: string;
    chargeRef?: string;
    httpCode?: string;
    plugRef?: string;
    reason?: string;
    requestDate?: number;
    startingMediumCode?: string;
    stationName?: string;
    stationRef?: string;
    status?: RemoteStatus;
    statusDate?: string;
    stoppingMediumCode?: string;
    remoteRef: string;
    otpSessionRef?: string;
    errorReason?: RemoteErrorReason;
    numberOfRetry?: number;
}

export enum RemoteStatus {
    WAIT_CHARGE_POINT = 'WAIT_CHARGE_POINT',
    REQUESTED = 'REQUESTED',
    DONE = 'DONE',
    ERROR = 'ERROR',
    TIMEOUT = 'TIMEOUT',
}

export enum RemoteErrorReason {
    CHARGER_NOT_FOUND = 'CHARGER_NOT_FOUND',
    CHARGE_NOT_FOUND = 'CHARGE_NOT_FOUND',
    EQUIPMENT_NOT_FOUND = 'EQUIPMENT_NOT_FOUND',
    NO_TRANSACTION_FOUND = 'NO_TRANSACTION_FOUND',
    NOT_SUPPORTED_CHARGE_POINT = 'NOT_SUPPORTED_CHARGE_POINT',
    OUT_OF_COMMUNICATION = 'OUT_OF_COMMUNICATION',
    PLUG_NOT_FOUND = 'PLUG_NOT_FOUND',
    PLUG_NOT_BUILT = 'PLUG_NOT_BUILT',
    PLUG_FAULTED = 'PLUG_FAULTED',
    REJECTED_BY_CHARGER = 'REJECTED_BY_CHARGER',
    UNKNOWN = 'UNKNOWN'
}

export interface RemoteRef {
    action?: Action;
    createDate?: string;
    ref?: string;
}

export enum Action {
    START = 'START',
    STOP = 'STOP',
}

export interface FrontRemoteRequest {
    chargeAreaRef?: string;
    chargePointVisualId?: string;
    chargePointRef?: string;
    mediaRef?: string;
    plugOrientation?: string;
    plugOutletModel?: string;
    stationAlias?: string;
}
